import { useState } from 'react'
import { dispatch } from 'store'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import AvatarActionFlyoutButton from '../flyout/AvatarActionFlyoutButton'
import AvatarActionFlyoutPanel from '../flyout/AvatarActionFlyoutPanel'
import ResizeAspectRatioSelector from '../resize-aspect-ratio-selector/ResizeAspectRatioSelector'
import { useResizeImageModel } from './useSourceImageModel'
import * as Styled from './styled'

// Panel content is its own component so the picked ratio resets on every
// open — Flyout/SlideUp unmount their children when closed. Nothing is
// preselected: the CTA stays disabled until the user picks a ratio.
const ResizePanel = ({ close }: { close: () => void }) => {
  const { aspectRatios, cost } = useResizeImageModel()
  const [pickedRatio, setPickedRatio] = useState<string | null>(null)

  return (
    <AvatarActionFlyoutPanel
      title={translate(T.RESIZE_WITH_AI_LABEL)}
      ctaLabel={translate(T.RESIZE_LABEL)}
      cost={cost}
      isCtaDisabled={pickedRatio === null}
      onConfirm={() => {
        if (pickedRatio === null) return
        close()
        dispatch(aiAvatarThunks.resizeAvatarImage(pickedRatio))
      }}
    >
      <ResizeAspectRatioSelector
        options={aspectRatios}
        value={pickedRatio}
        onChange={setPickedRatio}
      />
    </AvatarActionFlyoutPanel>
  )
}

const ResizeAvatarButton = () => (
  <AvatarActionFlyoutButton
    icon={<Styled.ResizeIcon />}
    tooltipText={translate(T.RESIZE_WITH_AI_LABEL)}
    testId="avatar-preview-resize"
  >
    {close => <ResizePanel close={close} />}
  </AvatarActionFlyoutButton>
)

export default ResizeAvatarButton
